export default "__VITE_ASSET__C0g2qqBm__"